import { configOptions } from "./types";
import { defaultBatchingConfig } from "@grafana/faro-core";
export const DEFAULT_CONFIG: configOptions = {
  app: {
    name: "telemetry-web-sdk",
    version: "1.0.0",
    environment: "development"
  },
  debug: false,
  dedupe: false,
  batching: {
    ...defaultBatchingConfig
  },
  stacktraceParse: false,
  ignoreUrls: [],
  propagateTraceHeaderCorsUrls: [],
  collectorUrl: "",
  apiKey: "api-key",
  instrumentations: {
    documentload: true,
    xhr: true,
    fetch: true,
    interactions: true,
    webvitals: true,
    console: true,
    errors: true
  },
  sessionTracking: {
    enabled: true,
    persistent: true,
    maxSessionPersistenceTime: 300000
  },
  sso_user: true,
  sessionSampler: {
    ratio: 1.0
  },
  notifyOnBufferFullLimit: 5,
  transportBufferSize: 30,
  spanLimitInTrace: 2,
  scheduledDelayInTrace: 5000,
  rateLimitBackoffMs: 5000,
  useSendBeacon: true
};
